import React, { useState } from 'react';
import AdminLayout from './AdminLayout';
import ResourcePanel from './ResourcePanel';
import { PageHeading } from './ConsoleUI';

export function ResourceTabs({ tabs }) {
  const [active, setActive] = useState(tabs[0].resource);
  const tab = tabs.find((item) => item.resource === active) || tabs[0];
  return <div className="space-y-5"><div className="flex gap-2 overflow-x-auto border-b border-slate-800 pb-3" role="tablist" aria-label="Data sections">{tabs.map((item) => <button key={item.resource} type="button" role="tab" aria-selected={active === item.resource} onClick={() => setActive(item.resource)} className={`whitespace-nowrap rounded-lg px-4 py-2.5 text-sm font-medium ${active === item.resource ? 'bg-cyan-400/10 text-cyan-300 ring-1 ring-cyan-400/25' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`}>{item.title}</button>)}</div><div role="tabpanel"><ResourcePanel key={tab.resource} resource={tab.resource} title={tab.title} columns={tab.columns} /></div></div>;
}

export default function ResourceWorkspace({ title, tabs, children }) {
  return <AdminLayout><PageHeading title={title}  />{children && <div className="mb-6">{children}</div>}<ResourceTabs tabs={tabs} /></AdminLayout>;
}
